<section class="route-timeline__timeline">
  @for (segment of timelineSegments; track segment.hour) {
    @for (part of segment.segments; track part.time) {
      @if (part.type === 'big') {
        <app-hour
          [status]="part.status"
          [attr.data-hour]="segment.hour"
        >
          {{ segment.hour | translate }}
        </app-hour>
      }
      @else if (part.type === 'medium' && segment.hour !== '00') {
        <app-thirteen-minutes [status]="part.status" />
      }
      @else if (part.type === 'small' && segment.hour !== '00') {
        <app-fifteen-minutes
          [class]="part.status === 'present' ? 'present' : ''"
          [status]="part.status" 
        />
      }
    }
  }
</section>
